import { create } from 'zustand';

interface DealFilters {
  status?: string[];
  endDatePassed?: boolean;
  withoutEndDate?: boolean;
}

interface DealState {
  filters: DealFilters;
  setFilters: (filters: DealFilters) => void;
}

export const useDealStore = create<DealState>()((set) => ({
  filters: {},
  setFilters: (filters: DealFilters) => set(() => ({ filters })),
})); 